module.exports = __webpack_public_path__ + "0e23cfc09e913ca77bbdc9a688edcb8a.MP3";